// 问卷调查
export default [
  // 首页
  {
    path: '/questionnaireIndex',
    name: 'questionnaireIndex',
    component: () =>
    import(/* webpackChunkName: "questionnaire" */ '@/components/bloom-questionnaire/index')
  },
  // 问卷状态页面
  {
    path: '/questionnaireState',
    name: 'questionnaireState',
    component: () =>
    import(/* webpackChunkName: "questionnaire" */ '@/components/bloom-questionnaire/state')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/questionnaire.js